import { WaitingScope } from 'src/components/waiting/waiting.scopes'
import { Observable, observe, Scope } from 'wdc-cube'
import { GroupRow } from '../../group-manager/gm_scopes'
import type { UserRow } from '../um_scopes'

@Observable
export class UserManagerFormScope extends Scope {
    @observe() waiting?: WaitingScope

    @observe() userEditing?: UserRow
    @observe() formData = {
        active: true
    } as UserRow

    @observe() groups?: GroupRow[]
    @observe() showPassword = false
    @observe() adminGestaoEditable = false
    @observe() protectedGestor = false

    onFormDataChange = Scope.ASYNC_ACTION_ONE<Partial<UserRow>>()
    onGenerateRandomPassword = Scope.ASYNC_ACTION

    onSave = Scope.ASYNC_ACTION
    onClose = Scope.ASYNC_ACTION
    onChangePassword = Scope.ASYNC_ACTION
}

export default UserManagerFormScope
